import useStore from '../../../store'
import { useState } from 'react'
import { Widget, WidgetBody, WidgetHeader, WidgetFooter } from '../../ui/Widget'
import VCIDealerRow from './VCIDealerRow'
import AmSearchBar from '../../common/AmSearchBar'
import Pagination from '../../common/Pagination'

export default function Dealers() {
  const dealers = useStore((state) => state.dealers)
  const dealersFetching = useStore((state) => state.dealersFetching)
  const setDealerFilterAttribute = useStore((state) => state.setDealerFilterAttribute)
  const { currentPage, lastPage, dealerResultsCount, totalPages } = useStore((state) => state.dealerPaginationData)
  const setDealersPage = useStore((state) => state.setDealersPage)

  const [searchTerm, setSearchTerm] = useState('')

  const handlePageClick = (event) => {
    setDealersPage(event.selected + 1)
  }

  const handleSearch = (value) => {
    setDealerFilterAttribute(`search=${value}`)
  }

  const handleResetFilter = () => {
    setSearchTerm('')
    setDealerFilterAttribute('default')
  }

  return(
    <Widget>
      <WidgetHeader title="Dealers">
        <AmSearchBar
          handleSearch={handleSearch}
          handleReset={handleResetFilter}
          showFilterIcon={false}
          dataFetching={dealersFetching}
          searchBarValue={searchTerm}
          setSearchBarValue={setSearchTerm}
        />
      </WidgetHeader>
      <WidgetBody>
        {dealers?.map((dealer) => (
          <VCIDealerRow
            key={dealer.id}
            dealer={dealer}
            searchTerm={searchTerm}
          />
        ))}
      </WidgetBody>
      <WidgetFooter isSticky>
        <Pagination
          currentPage={currentPage}
          lastPage={lastPage}
          dataTotal={dealerResultsCount}
          handlePageClick={handlePageClick}
          totalPages={totalPages}
          styles='py-4'
        />
      </WidgetFooter>
    </Widget>
  )
}